<template>
  <div>
    <h2 class="mb-0h" :style="{ color: color }">{{ $t('consumables.tube.header') }}</h2>
    <div class="row align-center pr-1">
      <div class="col-6">
        <AlertBadge
          :alert="tube.hasWarning"
          style="max-width: 9rem"
        >
          <PumpLifetime
            :value="tube.remaining"
            :color="color"
          />
        </AlertBadge>
      </div>
      <div class="col-6">
        <div class="mb-1">
          <table>
            <tbody>
              <tr>
                <td>{{ $t('consumables.tube.lifespan') }}</td>
                <td><span class="large-text">{{ tube.remaining }}</span> %</td>
              </tr>
              <tr>
                <td>{{ $t('consumables.tube.daysToChange') }}</td>
                <td>
                  <span class="large-text">{{ tube.remainingDays }}</span>
                  {{ $t(formatGrammaticalNumber('common.unit.day', tube.remainingDays)) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AlertBadge from '@acs/components-library/src/components/common/AlertBadge.vue';
import PumpLifetime from '@acs/components-library/src/components/deviceDetail/diagrams/PumpLifetime.vue';
import formatGrammaticalNumber from '@acs/components-library/src/helpers/gramaticalNumber.js';

export default {
  components: {
    PumpLifetime,
    AlertBadge,
  },
  props: {
    color: {
      type: String,
      required: true,
    },
    tube: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formatGrammaticalNumber,
  },
};
</script>

<style lang="scss" scoped>
.btn.local {
  height: 2.5rem;
  cursor: initial;
}

span.large-text {
  font-size: 1.5rem;
  line-height: 1.5rem;
}

span.medium-text {
  font-size: 1rem;
  line-height: 1.5rem;
}
</style>
